import { useCallback, useEffect, useMemo, useState } from "react"

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useErrorBoundaryFactory = ({ fetch, siteSelected }) => {
  const [previousPathnames, setPreviousPathname] = useState([])
  const { pathname } = window.location
  useEffect(() => {
    setPreviousPathname(prevState => {
      if (prevState.length <= 3) {
        return [...prevState, pathname]
      }
      return [...prevState.slice(1), pathname]
    })
  }, [pathname])

  const parsePayload = useCallback(payload => {
    if (siteSelected) {
      const { key, id } = siteSelected
      if (!payload[key]) {
        payload[key] = id
      }
    }
    return payload
  }, [siteSelected])

  const save = useCallback(async payload => {
    payload.errorDetails = {
      ...payload.errorDetails,
      previousPathnames,
    }

    return await fetch({
      method: 'post',
      url: 'app-error',
      data: parsePayload(payload),
    })
  }, [fetch, parsePayload, previousPathnames])

  return useMemo(() => ({
    useSubmit: () => useCallback(async payload => save(payload), []),
  }), [save])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extend(useErrorBoundaryFactory)
  .factory()

export {
  Provider as GlobalErrorBoundaryProvider,
  useStore as useGlobalErrorBoundaryStore,
}
